export const Divider = () => <div className="border-1 my-6 border-t border-stone-200" />;

export default Divider;
